<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M2.5002 2.5H17.5002C17.9604 2.5 18.3335 2.8731 18.3335 3.33333V5.83333C18.3335 6.29357 17.9604 6.66667 17.5002 6.66667H2.5002C2.03997 6.66667 1.66687 6.29357 1.66687 5.83333V3.33333C1.66687 2.8731 2.03997 2.5 2.5002 2.5Z"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.33313 6.66656V15.8332C3.33313 16.2753 3.50872 16.6992 3.82129 17.0117C4.13385 17.3243 4.55777 17.4999 4.9998 17.4999H14.9998C15.4418 17.4999 15.8657 17.3243 16.1783 17.0117C16.4909 16.6992 16.6665 16.2753 16.6665 15.8332V6.66656"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.33313 10H11.6665"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconArchive',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	}
}
</script>
